"use client";

import { UnhandledRunTimeError as DSUnhandledRunTimeError } from "@offstreetparking/design-system/feedback";
import { buildSupportUrl } from "@offstreetparking/portal-flow/utils/support-url";

type UnhandledRunTimeErrorProps = {
	eventId: string | null;
	error: unknown;
	parkerId?: number;
	onReload: () => void;
};

export const UnhandledRunTimeError = ({ eventId, error, parkerId, onReload }: UnhandledRunTimeErrorProps) => {
	const supportUrl = buildSupportUrl({ parkerId });
	return (
		<DSUnhandledRunTimeError
			eventId={eventId}
			error={error}
			onReload={onReload}
			i18n={{
				title: "Something went wrong",
				message: (
					<>
						Please refresh and retry. If the issue persists, please{" "}
						<a
							className="text-neutral-faded underline"
							href={supportUrl}
							target="_blank"
							rel="noopener noreferrer"
						>
							contact us
						</a>
						.
					</>
				),
				reloadButton: "Reload",
				copied: "Copied!",
				copyToClipboard: "Copy to clipboard",
			}}
		/>
	);
};
